module.exports = __webpack_public_path__ + "static/media/BlackCloudNinja_Engine_Final.502704b0.png";